export const GLOSSARY =
[
    {
       "key":1,
       "value":"Admissible Evidence",
       "description":"Evidence that is relevant to determining a fact. The fact that the evidence seeks to determine must be material (in other words, related) to the case. In addition, the evidence must be competent, meaning that it must have been obtained legally. Evidence that results from an illegal search would be inadmissible because it is not competent."
    },
    {
       "key":2,
       "value":"Advanced Encryption Standard (AES)",
       "description":"A widely used symmetric encryption algorithm that uses 128-bit blocks and supports three key sizes: 128, 192, and 256. AES is based on the symmetric Rijndael block cipher."
    },
    {
       "key":3,
       "value":"Advanced Persistent Threats (APTs)",
       "description":"(1) An organized group of attackers who are highly motivated, skilled, and patient. They are often sponsored by a government, are focused on a specific target, and will continue attacking for a very long time until they achieve their goal. (2) Any form of cyberattack perpetrated by attackers that is able to exploit a target continuously over a considerable period of time. An APT often takes advantage of unknown flaws (that is, not publicly known) and tries to maintain stealth throughout the attack. The name is derived from the concept that the attacks are unique and exploit flaws that are not public knowledge (that is, this state of using an exploit against an unknown flaw is labeled as advanced), that the exploit grants the attackers ongoing remote access to and control over the target (that is, it\u0027s persistent), and that the attackers are likely nation-states (that is, it\u0027s a threat)."
    },
    {
       "key":4,
       "value":"Agent-Based Scanning",
       "description":"Administrators install small software agents on each target server. Conduct scans of the server configuration, providing an \u0022inside-out\u0022 vulnerability scan, and then report the information back to the vulnerability management platform for analysis and reporting."
    },
    {
       "key":5,
       "value":"Agile",
       "description":"A software development life cycle (SDLC) model based on adaptive development, in which focusing on a working product and fulfilling customer needs is prioritized over rigid adherence to a process, use of specific tools, and detailed documentation."
    },
    {
       "key":6,
       "value":"Alteration",
       "description":"The unauthorized modification of information and a violation of the principle of integrity."
    },
    {
       "key":7,
       "value":"Always-On VPN",
       "description":"When all corporate mobile devices are configured to automatically connect to the VPN whenever they are powered on."
    },
    {
       "key":8,
       "value":"Anomaly Detection",
       "description":"Attempts to develop a model of normal activity and then report deviations from that model as suspicious."
    },
    {
       "key":9,
       "value":"Annualized Loss Expectancy (ALE)",
       "description":"The amount of damage expected from a risk each year."
    },
    {
       "key":10,
       "value":"Annualized Rate of Occurrence (ARO)",
       "description":"The expected frequency of statistical probability that a specific threat or risk will occur within a single year."
    },
    {
       "key":11,
       "value":"API Inspection",
       "description":"Technology that scrutinizes API requests, looking for requests that pose security issues."
    },
    {
       "key":12,
       "value":"Approval Statement",
       "description":"Clearly describes the authority under which a security program is enacted."
    },
    {
       "key":13,
       "value":"Artifacts",
       "description":"The items of evidence that you maintain and may use in court."
    },
    {
       "key":14,
       "value":"Assessments",
       "description":"Reviews of security controls that are typically requested by the security organization itself in an effort to engage in process improvement. Assessments are less formal than audits."
    },
    {
       "key":15,
       "value":"Asset",
       "description":"Anything within an environment that should be protected. Any item used in a business task. The loss or disclosure of an asset could result in an overall security compromise, loss of productivity, reduction in profits, additional expenditures, discontinuation of the organization, and numerous intangible consequences."
    },
    {
       "key":16,
       "value":"Asset Criticality",
       "description":"Estimate of the priority/value of the asset to the organization. Helps guide decisions about the types of scans that are performed, the frequency of those scans, and the priority administrators should place on remediating vulnerabilities detected by the scan."
    },
    {
       "key":17,
       "value":"Asset Management",
       "description":"The process of keeping track of the hardware and software implemented by an organization."
    },
    {
       "key":18,
       "value":"Asset Owner",
       "description":"The person who is responsible for classifying information for placement and protection within the security solution. The asset owner is typically a high-level manager who is ultimately responsible for asset protection. However, the asset owner usually delegates the responsibility of the actual data management tasks to a custodian. Aka system owner."
    },
    {
       "key":19,
       "value":"Asset Return Agreements",
       "description":"Where the employee agrees to return all of the organization\u0027s property at the end of employment."
    },
    {
       "key":20,
       "value":"Asset Valuation",
       "description":"A dollar value assigned to an asset based on actual cost and nonmonetary expenses—such as costs to develop, maintain, administer, advertise, support, repair, and replace—as well as other values—such as public confidence, industry support, productivity enhancement, knowledge equity, and ownership benefits."
    },
    {
       "key":21,
       "value":"Asset Value",
       "description":"A dollar value assigned to an asset based on actual cost and nonmonetary expenses."
    },
    {
       "key":22,
       "value":"Asymmetric Cryptosystems",
       "description":"A form of encryption in which two keys must be used. One key is used to encrypt data, and the other is needed to decrypt the data. This is the opposite of symmetric encryption, in which a single key serves both purposes."
    },
    {
       "key":23,
       "value":"Auditability",
       "description":"Language in managed service contracts guaranteeing the right of the customer to audit cloud service providers."
    },
    {
       "key":24,
       "value":"Audits",
       "description":"Formal reviews of an organization\u0027s security program or specific compliance issues."
    },
    {
       "key":25,
       "value":"Authentication",
       "description":"The means of verifying that someone is who they say they are. There are various levels (factors) of authentication: single-factor, two-factor, three-factor, and so on. For instance, under a Public Key Infrastructure (PKI) system, two-factor authentication can be achieved by using both a password and a smartcard containing a digital certificate. Authentication can also be achieved via the authentication mechanisms included in Remote Authentication Dial-In User Service (RADIUS) or Terminal Access Controller Access Control System Plus (TACACS+), as well as more specialized protocols such as Kerberos."
    },
    {
       "key":26,
       "value":"Authorization",
       "description":"A process that ensures that the requested activity or object access is possible given the rights and privileges assigned to the authenticated identity (in other words, subject). The collection of rights, permissions, and privileges that are assigned to users. It\u0027s what users are authorized to do within a secured infrastructure. Commonly represented by access control lists."
    },
    {
       "key":27,
       "value":"Availability",
       "description":"The security service that provides protection for the use of a resource in a timely and effective manner. It is the assurance that authorized subjects are granted timely and uninterrupted access to objects."
    },
    {
       "key":28,
       "value":"Baselining",
       "description":"A snapshot of a system or application at a given point in time. Used to assess whether a system has changed outside of an approved change management process."
    },
    {
       "key":29,
       "value":"Best Evidence Rule",
       "description":"States that when a document is used as evidence in a court proceeding, the original document must be introduced."
    },
    {
       "key":30,
       "value":"Beyond a Reasonable Doubt",
       "description":"Standard of evidence where the prosecution must demonstrate that the defendant committed the crime by presenting facts from which there are no other logical conclusions."
    },
    {
       "key":31,
       "value":"Biometric",
       "description":"The use of human physiological or behavioral characteristics or traits as authentication factors for logical access and identification for physical access."
    },
    {
       "key":32,
       "value":"Black-Box",
       "description":"Testing that proceeds without using any knowledge of how an organization is structured, what kinds of hardware and software it uses, or its security policies, processes, and procedures."
    },
    {
       "key":33,
       "value":"Black-Hat Hackers",
       "description":"Also known as unauthorized attackers, black-hat hackers are those with malicious intent. They seek to defeat security controls and compromise the confidentiality, integrity, or availability of information and systems for their own unauthorized purposes."
    },
    {
       "key":34,
       "value":"Blue Team",
       "description":"The group defined as the defenders in a penetration test or security assessment exercise. See also red team and white team."
    },
    {
       "key":35,
       "value":"Board of Directors",
       "description":"The group of elected individuals who direct the actions of the corporation on behalf of the shareholders. Those individuals have ultimate authority over the organization."
    },
    {
       "key":36,
       "value":"Budget",
       "description":"A financial plan for a team that outlines how much money is available to them over the course of the year and how they plan to spend that money."
    },
    {
       "key":37,
       "value":"Business Continuity Planning (BCP)",
       "description":"A contingency planning process that allows a business to keep running in the event of a disruption to vital resources. The assessment of a variety of risks to organizational processes, the impact those risks might have on the organization if they were to occur, and the development of response scenarios to those concerns."
    },
    {
       "key":38,
       "value":"Business Impact Analysis (BIA)",
       "description":"A formal process designed to identify the missionessential functions within an organization and facilitate the identification of the critical systems that support those functions."
    },
    {
       "key":39,
       "value":"Business Partnership Agreement (BPA)",
       "description":"A contract between two entities dictating their business relationship. It clearly defines the expectations and obligations of each partner in the endeavor."
    },
    {
       "key":40,
       "value":"Business Purpose",
       "description":"The clear linking of the information security program objectives to business objectives."
    },
    {
       "key":41,
       "value":"Capital Expenses (CapEx)",
       "description":"Costs that an organization incurs as part of building out and maintaining its large assets."
    },
    {
       "key":42,
       "value":"Capture the Flag (CTF)",
       "description":"Exercises that pit technologists against one another in an attempt to attack a system and achieve a specific goal."
    },
    {
       "key":43,
       "value":"Center for Internet Security (CIS)",
       "description":"An industry organization that publishes hundreds of benchmarks for commonly used platforms."
    },
    {
       "key":44,
       "value":"Certificate Authorities (CAs)",
       "description":"Entities that authenticate public keys and distribute digital certificates."
    },
    {
       "key":45,
       "value":"Certificate Signing Request (CSR)",
       "description":"A message sent from an applicant to a registration authority of the Public Key Infrastructure in order to apply for a digital identity certificate."
    },
    {
       "key":46,
       "value":"Certificate Stapling",
       "description":"A means for checking the revocation status of X.509 digital certificates. It is a mechanism that enables the presenter of a certificate to append or staple a timestamped OCSP response signed by the issuing certificate authority (CA)."
    },
    {
       "key":47,
       "value":"Certification",
       "description":"The act of passing one or more exams to earn certification credentials (and impressive acronyms to add to your resume), which verify that you possess certain knowledge, skills, and expertise."
    },
    {
       "key":48,
       "value":"Change Advisory Board (CAB)",
       "description":"A group of people who run formal meetings to assess, prioritize, authorize, and schedule changes as part of the change control process."
    },
    {
       "key":49,
       "value":"Change Management",
       "description":"Processes that ensure organizations follow a standardized process for requesting, reviewing, approving, and implementing changes to information systems."
    },
    {
       "key":50,
       "value":"Charter",
       "description":"The organizing document for the cybersecurity program."
    },
    {
       "key":51,
       "value":"Chief Executive Officer (CEO)",
       "description":"Individual hired by the board of directors to serve as an organization\u0027s most senior employee."
    },
    {
       "key":52,
       "value":"Chief Information Security Officer (CISO)",
       "description":"Most senior information security leader within an organization who bears overall responsibility for ensuring that the information security program is properly designed, implemented, and operated."
    },
    {
       "key":53,
       "value":"Closed Source Intelligence",
       "description":"Intelligence information, typically from a commercial vendor that is provided only to specific groups."
    },
    {
       "key":54,
       "value":"Cloud Access Security Brokers (CASBs)",
       "description":"A security policy enforcement solution that consistently enforces security policies across cloud providers."
    },
    {
       "key":55,
       "value":"Cloud Auditors",
       "description":"Independent organizations that provide third-party assessments of cloud services and operations"
    },
    {
       "key":56,
       "value":"Cloud Carriers",
       "description":"The intermediaries that provide the connectivity that allows the delivery of cloud services from providers to consumers."
    },
    {
       "key":57,
       "value":"Cloud Computing",
       "description":"A model for enabling ubiquitous, convenient, on-demand network access to a shared pool of configurable computing resources."
    },
    {
       "key":58,
       "value":"Cloud Consumers",
       "description":"The organizations and individuals who purchase cloud services from cloud service providers."
    },
    {
       "key":59,
       "value":"Cloud Partners",
       "description":"Organizations that offer ancillary products or services that support or integrate with the offerings of a cloud service provider."
    },
    {
       "key":60,
       "value":"Cloud Service Providers",
       "description":"The firms that offer cloud computing services to their customers."
    },
    {
       "key":61,
       "value":"CMMI (Capability Maturity Model Integration)",
       "description":"A formal software development management concept that describes the process that organizations undertake as they move toward incorporating solid engineering principles into their software development processes."
    },
    {
       "key":62,
       "value":"Code Review",
       "description":"The act of consciously and systematically convening with one\u0027s fellow programmers to check each other\u0027s code for mistakes."
    },
    {
       "key":63,
       "value":"Cold Sites",
       "description":"Standby facilities large enough to handle the processing load of an organization and equipped with appropriate electrical and environmental support systems."
    },
    {
       "key":64,
       "value":"Community Cloud",
       "description":"Cloud delivery model in which the infrastructure is shared by organizations with something in common."
    },
    {
       "key":65,
       "value":"Compensating Controls",
       "description":"Controls designed to mitigate the risk associated with exceptions made to a security policy."
    },
    {
       "key":66,
       "value":"Compliance Risk",
       "description":"The risk that a security breach causes an organization to run afoul of legal or regulatory requirements."
    },
    {
       "key":67,
       "value":"Computer-Based Training (CBT)",
       "description":"The use of a personal or networked computer for the delivery and access of training programs."
    },
    {
       "key":68,
       "value":"Computer Security Incident Response Teams (CSIRTs)",
       "description":"Responsible for responding to computer security incidents that occur within an organization by following standardized response procedures and incorporating their subject matter expertise and professional judgment."
    },
    {
       "key":69,
       "value":"Conclusive Evidence",
       "description":"Evidence that must as a matter of law be taken to establish some fact in issue and that cannot be disputed."
    },
    {
       "key":70,
       "value":"Confidence Score",
       "description":"Allow organizations to filter and use threat intelligence based on how much trust they can give it."
    },
    {
       "key":71,
       "value":"Confidentiality",
       "description":"The assurance that information is protected from unauthorized disclosure and the defined level of secrecy is maintained throughout all subject-object interactions."
    },
    {
       "key":72,
       "value":"Configuration Management",
       "description":"The process of logging, auditing, and monitoring activities related to security controls and security mechanisms over time. This data is then used to identify agents of change, whether objects, subjects, programs, communication pathways, or even the network itself."
    },
    {
       "key":73,
       "value":"Containment",
       "description":"Designed to isolate the incident and prevent it from spreading further. Continuous Deployment (CD) A development practice that transitions tested changes into the production environment automatically as soon as they have been tested."
    },
    {
       "key":74,
       "value":"Continuous Integration (CI)",
       "description":"A development practice that checks code into a shared repository on a consistent, ongoing basis."
    },
    {
       "key":75,
       "value":"Continuous Monitoring",
       "description":"A monitoring practice that uses automation to facilitate 24×7 monitoring of systems and networks."
    },
    {
       "key":76,
       "value":"Corrective Controls",
       "description":"A type of access control that modifies the environment to return systems to normal after an unwanted or unauthorized activity has occurred."
    },
    {
       "key":77,
       "value":"Cost Analysis",
       "description":"Outlines financial and human resource costs of the initiative, on both a onetime and recurring basis."
    },
    {
       "key":78,
       "value":"Credentialed Scans",
       "description":"May access operating systems, databases, and applications among other sources in order to retrieve information from targeted servers and do not make changes to the server itself."
    },
    {
       "key":79,
       "value":"Crossover Error Rate (CER)",
       "description":"The point at which the false rejection rate (FRR) and the false acceptance rate (FAR) are equal. Sometimes called the equal error rate (ERR)."
    },
    {
       "key":80,
       "value":"Cryptography",
       "description":"Algorithms applied to data that are designed to ensure confidentiality, integrity, authentication, and/or nonrepudiation."
    },
    {
       "key":81,
       "value":"DAD Triad",
       "description":"The three major threats to cybersecurity efforts: disclosure, alteration, and denial."
    },
    {
       "key":82,
       "value":"Dark Web",
       "description":"An anonymous network created through encryption technology and often used for illicit activity."
    },
    {
       "key":83,
       "value":"Data at Rest",
       "description":"Stored data that resides on hard drives, on tapes, in the cloud, or on other storage media."
    },
    {
       "key":84,
       "value":"Data Breach Notification Laws",
       "description":"Laws requiring the notification of data subjects after a known or suspected breach."
    },
    {
       "key":85,
       "value":"Data Controllers",
       "description":"In the context of a data processor, as defined by European Union data protection laws, the person or entity that controls the processing of the data."
    },
    {
       "key":86,
       "value":"Data Custodians",
       "description":"The user who is assigned the task of implementing the prescribed protection defined by the security policy and upper management. The data custodian performs all activities necessary to provide adequate protection for data and to fulfill the requirements and responsibilities delegated to them from upper management."
    },
    {
       "key":87,
       "value":"Data Exfiltration",
       "description":"An attack in which access to sensitive information is gained and then removed from an organization."
    },
    {
       "key":88,
       "value":"Data Loss Prevention (DLP)",
       "description":"Any systems that identify, monitor, and protect data to prevent it from unauthorized use, modification, destruction, egress, or exfiltration from a location."
    },
    {
       "key":89,
       "value":"Data Masking",
       "description":"Partially redacts sensitive information by replacing some or all sensitive fields with blank characters."
    },
    {
       "key":90,
       "value":"Data Minimization",
       "description":"Techniques used to reduce risk by reducing the amount of sensitive information that we maintain on a regular basis."
    },
    {
       "key":91,
       "value":"Data in Motion",
       "description":"Data that is in transit over a network."
    },
    {
       "key":92,
       "value":"Data Obfuscation",
       "description":"The process that transforms data into a format where the original information can\u0027t be retrieved."
    },
    {
       "key":93,
       "value":"Data Owners",
       "description":"The person responsible for classifying information for placement and protection within the security solution."
    },
    {
       "key":94,
       "value":"Data Processor",
       "description":"Third-party organizations that handle data on behalf of a data owner."
    },
    {
       "key":95,
       "value":"Data Retention",
       "description":"The policies of persistent data and records management for meeting legal and business data archival requirements."
    },
    {
       "key":96,
       "value":"Data Sovereignty",
       "description":"A principle that states that data is subject to the legal restrictions of any jurisdiction where it is collected, stored, or processed."
    },
    {
       "key":97,
       "value":"Data Steward",
       "description":"Handles the implementation of the high-level policies set by the data owner. Data Subjects The individuals about whom data is collected, stored, and processed."
    },
    {
       "key":98,
       "value":"Data in Use",
       "description":"Data that is active in a computer system where it may be accessed by a process running on that system."
    },
    {
       "key":99,
       "value":"Debug Modes",
       "description":"Give developers crucial error information needed to troubleshoot applications in the development process."
    },
    {
       "key":100,
       "value":"Degaussing",
       "description":"A form of purging that uses extremely strong magnetic fields to disrupt data stored on a device."
    },
    {
       "key":101,
       "value":"De-identification",
       "description":"A process that removes the ability to link data back to an individual, reducing its sensitivity."
    },
    {
       "key":102,
       "value":"Demonstrative Evidence",
       "description":"Evidence used to support testimonial evidence; items that may or may not be admitted into evidence themselves but are used to help a witness explain a concept or clarify an issue."
    },
    {
       "key":103,
       "value":"Denial",
       "description":"The unintended disruption of an authorized user\u0027s legitimate access to information."
    },
    {
       "key":104,
       "value":"Denial of Service (DoS)",
       "description":"An attack that makes a system or resource unavailable to legitimate users by sending thousands or millions of requests to a network, server, or application, overwhelming it and making it unable to answer any requests."
    },
    {
       "key":105,
       "value":"Deprovisioning",
       "description":"When a user leaves the organization, administrators ensure that the employee goes through an off-boarding process that includes removing their credentials and authorizations at the appropriate time."
    },
    {
       "key":106,
       "value":"Destroy",
       "description":"Renders target data recovery infeasible using state-of-the-art laboratory techniques and results in the subsequent inability to use the media for storage of data."
    },
    {
       "key":107,
       "value":"Detective Controls",
       "description":"A type of access control that is deployed to discover or detect unwanted or unauthorized activity."
    },
    {
       "key":108,
       "value":"Deterrent Controls",
       "description":"A type of access control that is deployed to discourage violation of security policies."
    },
    {
       "key":109,
       "value":"DevOps",
       "description":"The DevOps approach seeks to resolve issues of software development, quality assurance, and technology operations by bringing the three functions together in a single operational model. The word DevOps is a combination of development and operations, symbolizing that these functions must merge and cooperate to meet business requirements."
    },
    {
       "key":110,
       "value":"DevSecOps",
       "description":"DevOps model that includes security as a core component."
    },
    {
       "key":111,
       "value":"Differential Backups",
       "description":"A type of backup that stores all files that have been modified since the time of the most recent full backup."
    },
    {
       "key":112,
       "value":"Digital Certificate",
       "description":"An electronic document used to securely share a private key with third parties based on the assurance provided by a certificate authority (CA)."
    },
    {
       "key":113,
       "value":"Digital Rights Management (DLM)",
       "description":"A type of protection software that uses encryption to enforce copyright restrictions on digital media. Over the past decade, publishers attempted to deploy DRM schemes across a variety of media types, including music, movies, and books."
    },
    {
       "key":114,
       "value":"Digital Signatures",
       "description":"A method for assuring a recipient that a message truly came from the claimed sender and that the message was not altered while in transit between the sender and recipient. A digital signature is created by encrypting or signing the hash of the message with the private key of the sender."
    },
    {
       "key":115,
       "value":"Direct Evidence",
       "description":"Evidence that proves or disproves a specific act through oral testimony based on information gathered through the witness\u0027s five senses."
    },
    {
       "key":116,
       "value":"Disaster Recovery Planning (DRP)",
       "description":"The discipline of developing plans to recover operations as quickly as possible in the face of a disaster."
    },
    {
       "key":117,
       "value":"Disclosure",
       "description":"The occurrence of a violation of confidentiality when resources are made accessible to unauthorized entities; also known as data loss."
    },
    {
       "key":118,
       "value":"Disposition",
       "description":"Occurs when a product or system reaches the end of its life."
    },
    {
       "key":119,
       "value":"DMZ (demilitarized zone)",
       "description":"A network where you can place systems that must accept connections from the outside world."
    },
    {
       "key":120,
       "value":"Documentary Evidence",
       "description":"Any written items brought into court to prove a fact at hand."
    },
    {
       "key":121,
       "value":"Domain Validation (DV)",
       "description":"Certificates Certificate issued based upon the CA\u0027s verification that the certificate subject has control over a domain name."
    },
    {
       "key":122,
       "value":"Dynamic Testing",
       "description":"Evaluates the security of software in a runtime environment and is often the only option for organizations deploying applications written by someone else."
    },
    {
       "key":123,
       "value":"Elasticity",
       "description":"States that the capacity should expand and contract as needs change to optimize costs; closely related to scalability."
    },
    {
       "key":124,
       "value":"Electronic Discovery Reference Model (EDRM)",
       "description":"A framework that outlines standards for the recovery and discovery of digital data related to legal proceedings."
    },
    {
       "key":125,
       "value":"Encryption",
       "description":"The process of converting plain text that is readable by anyone into encrypted text or ciphertext. This ciphertext will be unreadable to anyone able to intercept it. The general rule is that all encryption can be broken if an attacker has enough time and resources. That said, the idea is to use encryption that is stronger than the data is valuable."
    },
    {
       "key":126,
       "value":"End of Life (EOL) or End of Service Life (EOSL)",
       "description":"A product or service that has reached the end of its life cycle, which prevents users from receiving updates."
    },
    {
       "key":127,
       "value":"Enterprise Risk Management (ERM)",
       "description":"A formal approach to risk analysis that begins with identifying risks, continues with determining the severity of each risk, and then results in adopting one or more risk management strategies to address each risk."
    },
    {
       "key":128,
       "value":"Evidence Production Procedures",
       "description":"Procedures that describe how the organization will respond to subpoenas, court orders, and other legitimate requests to produce digital evidence."
    },
    {
       "key":129,
       "value":"Exit Interviews",
       "description":"Interviews used to gather information about a departing employee\u0027s experience at the company and wish them well in their future endeavors."
    },
    {
       "key":130,
       "value":"Expert Opinion",
       "description":"When a witness has been accepted by the court as an expert in a certain field based on the other facts presented and their personal knowledge of the field."
    },
    {
       "key":131,
       "value":"Exposure Factor (EF)",
       "description":"Determines the amount of damage that will occur to the asset if the risk materializes; generally expressed as a percentage of the value of the asset."
    },
    {
       "key":132,
       "value":"Extended Validation (EV)",
       "description":"Certificates Provide a high level of assurance because the CA takes steps to verify that the certificate owner is a legitimate business before issuing the certificate."
    },
    {
       "key":133,
       "value":"External Risks",
       "description":"Risks that originate from a source outside the organization. This is an extremely broad category of risk, including cybersecurity adversaries and malicious code and natural disasters, among many other types of risk."
    },
    {
       "key":134,
       "value":"Fagan Inspection",
       "description":"A form of structured, formal code review intended to find a variety of problems during the development process."
    },
    {
       "key":135,
       "value":"Failover",
       "description":"A method of protecting computer systems from failure, where standby equipment automatically takes over when the main system fails."
    },
    {
       "key":136,
       "value":"False Acceptance Errors",
       "description":"Occur when a system misidentifies an individual as an authorized user and grants access that should be denied."
    },
    {
       "key":137,
       "value":"False Acceptance Rate (FAR)",
       "description":"The rate at which an authentication solution grants access to individuals it should have rejected."
    },
    {
       "key":138,
       "value":"False Negative",
       "description":"Errors Occur when an attack actually takes place but the intrusion detection system does not notice it."
    },
    {
       "key":139,
       "value":"False Positive Error",
       "description":"Occurs when a security tool reports an issue that does not exist."
    },
    {
       "key":140,
       "value":"False Rejection",
       "description":"Occurs when an authorized individual attempts to gain access to a system but is incorrectly denied access to the system."
    },
    {
       "key":141,
       "value":"False Rejection Rate (FRR)",
       "description":"The percentage of identification instances in which authorized persons are incorrectly denied access."
    },
    {
       "key":142,
       "value":"Family Educational Rights and Privacy Act (FERPA)",
       "description":"Federal law that requires that U.S. educational institutions implement security and privacy controls for student educational records."
    },
    {
       "key":143,
       "value":"Fault Tolerance",
       "description":"The ability of a system to suffer a fault but continue to operate. Financial Risk The risk of monetary damage to the organization as the result of a data breach."
    },
    {
       "key":144,
       "value":"Firewalls",
       "description":"Serve as security guards of a network, analyzing all attempts to connect to systems on a network and determining whether the request should be allowed or denied depending on the organization\u0027s security policy."
    },
    {
       "key":145,
       "value":"Fiscal Year",
       "description":"A one-year period that companies and governments use for financial reporting and budgeting."
    },
    {
       "key":146,
       "value":"Footprinting",
       "description":"The process of systematically identifying a network and its security posture. Full Backups Store a complete copy of the data contained on the protected device."
    },
    {
       "key":147,
       "value":"Full Interruption Tests",
       "description":"Shutting down operations at the primary site and shifting them to the recovery site."
    },
    {
       "key":148,
       "value":"Full-Disk Encryption",
       "description":"A type of disk encryption that encrypts the disk and requires that the bootloader or a hardware device provide a decryption key and software or hardware to decrypt the drive for use."
    },
    {
       "key":149,
       "value":"Full-Tunnel VPN",
       "description":"A virtual private network (VPN) that sends all network traffic through the VPN tunnel, keeping it secure as it goes to the remote trusted network."
    },
    {
       "key":150,
       "value":"Function as a Service (FaaS)",
       "description":"An example of platform-as-a-service (PaaS) computing that allows customers to upload their own code functions to the provider; the provider will then execute those functions on a scheduled basis, in response to events, and/or on demand."
    },
    {
       "key":151,
       "value":"Fuzzing",
       "description":"A method of testing that intentionally enters invalid input to see if the application can handle it."
    },
    {
       "key":152,
       "value":"Gamification",
       "description":"Designed to make training more enjoyable and help users retain the message of the campaign."
    },
    {
       "key":153,
       "value":"Gap Analysis",
       "description":"A process where cybersecurity managers can conduct an assessment of the current state of their controls and determine the degree to which they are achieving their control objectives."
    },
    {
       "key":154,
       "value":"General Data Protection Regulation (GDPR)",
       "description":"European Union law that provides a single, harmonized law covering data security and privacy."
    },
    {
       "key":155,
       "value":"Governance",
       "description":"Sets of procedures and controls put in place to allow an organization to effectively direct its work."
    },
    {
       "key":156,
       "value":"Gramm–Leach–Bliley Act (GLBA)",
       "description":"U.S. law passed in 1999 that eased the strict governmental barriers between financial institutions and insurers. It also created new security and privacy requirements."
    },
    {
       "key":157,
       "value":"Gray Box",
       "description":"A form of penetration testing that combines black-box and white-box testing techniques. In this approach, testers approach the software from a user perspective, analyzing inputs and outputs."
    },
    {
       "key":158,
       "value":"Gray-Hat Hackers",
       "description":"Hackers who fall somewhere between whiteand black-hat hackers. Also known as semi-authorized attackers."
    },
    {
       "key":159,
       "value":"Guideline",
       "description":"A document that offers recommendations on how standards and baselines are implemented. Guidelines outline methodologies, include suggested actions, and are not compulsory."
    },
    {
       "key":160,
       "value":"Hacker mindset",
       "description":"An approach for finding flaws by thinking like the adversary who might attack the system in the real world."
    },
    {
       "key":161,
       "value":"Hacktivists",
       "description":"People who use hacking techniques to accomplish an activist goal."
    },
    {
       "key":162,
       "value":"Hardware Security Module (HSM)",
       "description":"A cryptoprocessor used to manage/store digital encryption keys, accelerate cryptographic operations, support faster digital signatures, and improve authentication."
    },
    {
       "key":163,
       "value":"Hashing",
       "description":"Creation of a message digest from a message using a one-way cryptographic hash function."
    },
    {
       "key":164,
       "value":"Health Insurance Portability and Accountability Act (HIPAA)",
       "description":"U.S. health-care law that creates security and privacy requirements for handling protected health information."
    },
    {
       "key":165,
       "value":"Heuristic Detection",
       "description":"These systems attempt to model normal activity, then report when they discover activity that deviates from that normal pattern."
    },
    {
       "key":166,
       "value":"Horizontal Scaling",
       "description":"Scalability achieved by adding more servers to a pool of clustered servers."
    },
    {
       "key":167,
       "value":"Host-Based DLP",
       "description":"Uses software agents installed in a single system that search the system for the presence of sensitive information."
    },
    {
       "key":168,
       "value":"Hot Site",
       "description":"A backup facility is maintained in constant working order, ready to assume responsibilities of the primary operations."
    },
    {
       "key":169,
       "value":"Hybrid Cloud",
       "description":"Cloud deployments that blend public, private, and/or community cloud services together."
    },
    {
       "key":170,
       "value":"Hypertext Transfer Protocol (HTTP)",
       "description":"The protocol used for communication between a web server and a web browser."
    },
    {
       "key":171,
       "value":"Hypervisor",
       "description":"Software that manages the access of virtual machines to underlying hardware resources."
    },
    {
       "key":172,
       "value":"Identification",
       "description":"When an individual makes a claim about their identity."
    },
    {
       "key":173,
       "value":"Identity and Access Management (IAM)",
       "description":"The role that ensures that only authorized individuals gain access to information, systems, and networks under our protection."
    },
    {
       "key":174,
       "value":"Impact",
       "description":"A measurement of the amount of damage or loss that could or would be caused if a potential threat is ever realized."
    },
    {
       "key":175,
       "value":"Incremental Backups",
       "description":"A backup that stores only those files that have been modified since the time of the most recent full or incremental backup. This term is also used to mean the process of creating such a backup."
    },
    {
       "key":176,
       "value":"Incremental Budgeting",
       "description":"Approaches that start with the prior year\u0027s budget and then make adjustments by either raising or lowering that budget."
    },
    {
       "key":177,
       "value":"Independent Directors",
       "description":"The members of the board that have no significant relationship with the company other than their board membership."
    },
    {
       "key":178,
       "value":"Indicators of Compromise (IOCs)",
       "description":"The telltale signs that an attack has taken place may include file signatures, log patterns, and other evidence left behind by attackers."
    },
    {
       "key":179,
       "value":"Industrial Control System (ICS)",
       "description":"A form of computer-management device that controls industrial processes and machines. ICSs are used across a wide range of industries, including manufacturing, fabrication, power generation and distribution, water distribution, sewage processing, and oil refining. There are several forms of ICS, including distributed control systems (DCSs), programmable logic controllers (PLCs), and supervisory control and data acquisition (SCADA)."
    },
    {
       "key":180,
       "value":"Information Classification",
       "description":"The process of determining what information is accessible to what parties and for what purposes."
    },
    {
       "key":181,
       "value":"Information Security Policy",
       "description":"A document that provides high-level authority and guidance for the security program."
    },
    {
       "key":182,
       "value":"Information Security Policy Framework",
       "description":"A framework that contains a series of documents designed to describe the organization\u0027s cybersecurity program."
    },
    {
       "key":183,
       "value":"Infrastructure as a Service (IaaS)",
       "description":"A model of cloud computing that utilizes virtualization; clients pay an outsourcer for the resources used."
    },
    {
       "key":184,
       "value":"Infrastructure as Code (IaC)",
       "description":"The process of managing and provisioning computer data centers through machine-readable definition files."
    },
    {
       "key":185,
       "value":"Information Security Program",
       "description":"The collection of policies, standards, processes, activities, and projects that work together to achieve the goals set forth in the organization\u0027s information security strategy."
    },
    {
       "key":186,
       "value":"Information Security Strategy",
       "description":"Strategy that begins with an assessment of the current state of the organization and a comparison to the desired state of security based on the organization\u0027s control objectives. It then outlines a plan for working from that current state to achieve the desired state through clearly articulated goals."
    },
    {
       "key":187,
       "value":"Inherent Risk",
       "description":"The original level of risk that exists before implementing any controls."
    },
    {
       "key":188,
       "value":"Insider Attack",
       "description":"An attack that occurs when an employee, contractor, vendor, or other individual with authorized access to information and systems uses that access to wage an attack against the organization."
    },
    {
       "key":189,
       "value":"Integrity",
       "description":"The assurance that there are no unauthorized modifications to information or systems, either intentionally or unintentionally."
    },
    {
       "key":190,
       "value":"Intellectual Property (IP)",
       "description":"Theft Risks that occur when a company possesses trade secrets or other proprietary information that, if disclosed, could compromise the organization\u0027s business advantage."
    },
    {
       "key":191,
       "value":"Interactive Testing",
       "description":"Combines static and dynamic testing, analyzing the source code while testers interact with the application through exposed interfaces."
    },
    {
       "key":192,
       "value":"Internal Risks",
       "description":"Those risks that originate from within the organization."
    },
    {
       "key":193,
       "value":"International Organization for Standardization (ISO)",
       "description":"An organization that defines and maintains computer, networking, and technology standards, along with more than 13,000 other international standards for business, government, and society."
    },
    {
       "key":194,
       "value":"Internet Protocol Security (IPsec)",
       "description":"A secure network protocol suite that authenticates and encrypts the packets of data to provide secure encrypted communication between two computers over an Internet Protocol network."
    },
    {
       "key":195,
       "value":"Intranet",
       "description":"Web (or similar) services set up in a private network to be accessed internally only."
    },
    {
       "key":196,
       "value":"Intrusion Detection System (IDS)",
       "description":"A product that automates the inspection of audit logs and real-time system events. IDSs are generally used to detect intrusion attempts, but they can also be employed to detect system failures or to rate overall performance."
    },
    {
       "key":197,
       "value":"Intrusion Prevention System (IPS)",
       "description":"Tools that are designed to detect the attempts to gain unauthorized access and prevent the attempts from becoming successful."
    },
    {
       "key":198,
       "value":"Invoice Scams",
       "description":"A type of fraud that sends fake invoices to organizations in hopes of receiving payment."
    },
    {
       "key":199,
       "value":"Isolation",
       "description":"A concept that ensures that any behavior will affect only the memory and resources associated with the process. Also, the act of keeping something separated from others. Isolation can be used to prevent the commingling of information or disclosure of information."
    },
    {
       "key":200,
       "value":"ISO 27001",
       "description":"A standard covering security control objectives for information systems."
    },
    {
       "key":201,
       "value":"ISO 27002",
       "description":"A standard describing the actual controls that an organization may implement to meet cybersecurity objectives."
    },
    {
       "key":202,
       "value":"ISO 27701",
       "description":"A standard that contains guidance for managing privacy controls."
    },
    {
       "key":203,
       "value":"ISO 31000",
       "description":"A standard that provides guidelines for risk management programs."
    },
    {
       "key":204,
       "value":"Job rotation",
       "description":"A means by which an organization improves its overall security by rotating employees among numerous job positions. Job rotation serves two functions. First, it provides a type of knowledge redundancy. Second, moving personnel around reduces the risk of fraud, data modification, theft, sabotage, and misuse of information."
    },
    {
       "key":205,
       "value":"Key Goal Indicators (KGIs)",
       "description":"Metrics that measure progress toward defined goals."
    },
    {
       "key":206,
       "value":"Key Performance Indicators (KPIs)",
       "description":"Metrics that demonstrate the success of the security program in achieving its objectives."
    },
    {
       "key":207,
       "value":"Key Risk Indicators (KRIs)",
       "description":"Quantitative measures of risk that may be easily monitored for situations where they exceed a defined threshold value or worrisome trends."
    },
    {
       "key":208,
       "value":"Layer 2 Tunneling Protocol (LT2P)",
       "description":"A tunneling protocol used to support virtual private networks or as part of the delivery of services by ISPs."
    },
    {
       "key":209,
       "value":"Least Privilege",
       "description":"States that an individual should only have the minimum set of privileges necessary to complete their assigned job duties."
    },
    {
       "key":210,
       "value":"Legacy Systems",
       "description":"Older systems that pose a risk because they often do not receive security updates and extraordinary measures must be used to protect against their unpatchable vulnerabilities."
    },
    {
       "key":211,
       "value":"Lessons Learned",
       "description":"Designed to provide everyone involved with the incident response effort an opportunity to reflect on their individual role in the incident and the team\u0027s response overall."
    },
    {
       "key":212,
       "value":"Likelihood",
       "description":"The measurement of probability that a threat will become realized within a specific period of time."
    },
    {
       "key":213,
       "value":"Load Balancer",
       "description":"A system used to spread or distribute network traffic load across several network links or network devices. The purpose of load balancing is to obtain more optimal infrastructure utilization, minimize response time, maximize throughput, reduce overloading, and eliminate bottlenecks."
    },
    {
       "key":214,
       "value":"Malware",
       "description":"Malicious software that may arrive on a system when a user clicks a malicious link or installs unsafe software."
    },
    {
       "key":215,
       "value":"Managed Service Providers (MSPs)",
       "description":"Service organizations that provide information technology as a service to their customers. MSPs may handle an organization\u0027s IT needs completely, or they may offer focused services such as network design and implementation, application monitoring, or cloud cost management."
    },
    {
       "key":216,
       "value":"Managerial Controls",
       "description":"Sometimes called procedural or administrative controls, managerial controls are controls that are implemented through processes like awareness, training, and oversight."
    },
    {
       "key":217,
       "value":"Mandatory Access Control (MAC)",
       "description":"An access control mechanism that uses security labels to regulate subject access to objects. Implementations include using a hierarchical MAC environment, a compartmentalized MAC environment, and a hybrid MAC environment."
    },
    {
       "key":218,
       "value":"Man-in-the-Middle Attack (On-Path Attack)",
       "description":"An attack that occurs when someone/ something intercepts packets and retransmits them to another party."
    },
    {
       "key":219,
       "value":"Masking",
       "description":"The process that partially redacts sensitive information by replacing some or all sensitive fields with blank or placeholder characters (such as X or *)."
    },
    {
       "key":220,
       "value":"Master Service Agreements (MSAs)",
       "description":"Agreements that provide an umbrella contract for the work that a vendor does with an organization over an extended period of time."
    },
    {
       "key":221,
       "value":"Maturity Models",
       "description":"An approach that describes the current and desired positioning of an organization along a continuum of progress."
    },
    {
       "key":222,
       "value":"Maximum Tolerable Downtime (MTD)",
       "description":"The maximum length of time a business function can tolerate a disruption before suffering irreparable harm; also known as Maximum Tolerable Outage (MTO) and Maximum Allowable Downtime (MAD)."
    },
    {
       "key":223,
       "value":"Mean Time Between Failures (MTBF)",
       "description":"A measure of the reliability of a system obtained by measuring the average time between system failures"
    },
    {
       "key":224,
       "value":"Mean Time to Repair (MTTR)",
       "description":"The average amount of time to restore a system to its normal operating state after a failure."
    },
    {
       "key":225,
       "value":"Measured Boot",
       "description":"A boot process that provides a trusted log of all components like drivers and other components loaded during a boot process."
    },
    {
       "key":226,
       "value":"Media Analysis",
       "description":"A branch of computer forensic analysis that involves the identification and extraction of information from storage media."
    },
    {
       "key":227,
       "value":"Memorandum of Understanding (MOU)",
       "description":"A letter written to document aspects of a business relationship."
    },
    {
       "key":228,
       "value":"Memory Leak",
       "description":"One example of resource exhaustion; if an application requests memory from the operating system, it will eventually no longer need that memory and should then return the memory to the operating system for other uses."
    },
    {
       "key":229,
       "value":"Memory Pointer",
       "description":"An area of memory that stores an address of another location in memory."
    },
    {
       "key":230,
       "value":"Metadata",
       "description":"The results of a data mining operation on a data warehouse. Metadata is often referred to as \u0022data about data.\u0022"
    },
    {
       "key":231,
       "value":"Metrics",
       "description":"Quantitative data collected to assess the efficiency and effectiveness of critical security controls."
    },
    {
       "key":232,
       "value":"Minimum Security Standards for Electronic Information",
       "description":"A document that divides information into four different data protection levels (DPLs) and then describes what controls are required, optional, and not required for data at different levels, using a detailed matrix."
    },
    {
       "key":233,
       "value":"Mobile Metadata",
       "description":"A type of metadata that is collected by phones and other mobile devices as they are used."
    },
    {
       "key":234,
       "value":"Monitoring Procedures",
       "description":"Procedures that describe how the organization will perform security monitoring activities, including the possible use of continuous monitoring technology."
    },
    {
       "key":235,
       "value":"Multifactor Authentication (MFA)",
       "description":"Authentication that relies on two or more distinct authentication factors from the set of something you know, something you have, and something you are."
    },
    {
       "key":236,
       "value":"Multiparty Risks",
       "description":"Those risks that impact more than one organization."
    },
    {
       "key":237,
       "value":"Multitenancy",
       "description":"The fact that many different users share resources in the same cloud infrastructure."
    },
    {
       "key":238,
       "value":"Next-Generation Firewalls (NGFWs)",
       "description":"Firewalls that incorporate contextual information into their decision-making process, including information about users, applications, and business processes. They are the current state-of-the-art in network firewall protection and provide a variety of other advanced capabilities, but they also cost more than simpler products."
    },
    {
       "key":239,
       "value":"Network Time Protocol (NTP)",
       "description":"A networking protocol for clock synchronization between computer systems over data networks."
    },
    {
       "key":240,
       "value":"Nondisclosure Agreements (NDAs)",
       "description":"Legal agreement between two entities that protects the confidentiality of information used in the relationship."
    },
    {
       "key":241,
       "value":"Nonrepudiation",
       "description":"Provides assurance to the recipient that the message was originated by the sender and not someone pretending to be the sender."
    },
    {
       "key":242,
       "value":"OAuth",
       "description":"Open Standard for Authorization, a common method for authorizing websites or applications to access information."
    },
    {
       "key":243,
       "value":"Obfuscation",
       "description":"The practice of making it intentionally difficult for humans to understand how code works."
    },
    {
       "key":244,
       "value":"Object Storage",
       "description":"Provides customers with the ability to place files in buckets and treat each file as an independent entity that may be accessed over the web or through the provider\u0027s API."
    },
    {
       "key":245,
       "value":"Offboarding",
       "description":"The process of removing a staff member from an organization, often as part of a termination process. Disabling accounts, removing rights and privileges, and reclaiming organizational property and devices are all part of common offboarding processes."
    },
    {
       "key":246,
       "value":"Offsite Storage",
       "description":"Storing data off the organization\u0027s operational premises, usually in a secure location."
    },
    {
       "key":247,
       "value":"Onboarding",
       "description":"The process of adding a new individual to an organization. Creating user accounts, providing accounts and privileges, and issuing required equipment, keys, access cards, and other necessities are typically part of onboarding processes."
    },
    {
       "key":248,
       "value":"On-Demand Self-Service Computing",
       "description":"Cloud resources are available when and where you need them."
    },
    {
       "key":249,
       "value":"One-Time Passwords",
       "description":"Passwords that can be used for only one attempted logon, after which they become invalid. One-time passwords are often implemented via software or hardware token."
    },
    {
       "key":250,
       "value":"Ongoing Operations and Maintenance",
       "description":"A software development phase, including patching, updating, minor modifications, and other work that goes into daily support."
    },
    {
       "key":251,
       "value":"Online Certificate Status Protocol (OCSP)",
       "description":"A real-time facility for verifying the validity of a digital certificate and confirming that it has not been revoked by the issuing certificate authority."
    },
    {
       "key":252,
       "value":"On-Path Attack",
       "description":"See man-in-the-middle attack."
    },
    {
       "key":253,
       "value":"OpenID",
       "description":"An open SSO standard maintained by the OpenID Foundation that can be used in conjunction with OAuth or on its own."
    },
    {
       "key":254,
       "value":"Open Source Threat Intelligence",
       "description":"Threat intelligence that is acquired from publicly available sources."
    },
    {
       "key":255,
       "value":"Operational Controls",
       "description":"The mechanisms and procedures used to ensure or maintain security on a day-to-day basis."
    },
    {
       "key":256,
       "value":"Operational Expenses (OpEx)",
       "description":"The costs of running the business day to day that don\u0027t involve purchasing or maintaining an asset."
    },
    {
       "key":257,
       "value":"Operational Risk",
       "description":"The risk to the organization\u0027s ability to carry out its day-to-day functions."
    },
    {
       "key":258,
       "value":"Out-of-Band Management",
       "description":"A management interface that is not accessed in the same way that the device or system is used. For network devices, this may be a separate port and VLAN, or a serial console."
    },
    {
       "key":259,
       "value":"Oversubscription",
       "description":"When a device or network is theoretically overloaded based on the maximum potential usage of devices connected to it. In a network, a core switch or router may be oversubscribed based on the access switch ports compared to the upstream bandwidth. In practice, networks rarely use the maximum bandwidth for all downstream devices, allowing oversubscription to work without causing issues under normal circumstances."
    },
    {
       "key":260,
       "value":"Over-the-Shoulder Code Review",
       "description":"A code review methodology that relies on a pair of developers, with one writing code while explaining what they are doing and the other developer watching and reviewing. Programmers are required to switch roles on a recurring basis."
    },
    {
       "key":261,
       "value":"Pair Programming",
       "description":"Places two developers at one workstation, ensuring that multiple developers review their code as they write it."
    },
    {
       "key":262,
       "value":"Parallel Tests",
       "description":"Relocating personnel to the alternative recovery site and implementing site activation procedures, without interrupting main facility operations."
    },
    {
       "key":263,
       "value":"Parol Evidence Rule",
       "description":"States that when an agreement between parties is put into written form, the written document is assumed to contain all the terms of the agreement, and no verbal agreements may modify the written agreement."
    },
    {
       "key":264,
       "value":"Pass-around Code Review",
       "description":"A code review process that relies on email or other distribution methods to distribute code for review."
    },
    {
       "key":265,
       "value":"Pass-the-Hash Attack",
       "description":"A form of replay attack that takes place against the operating system rather than a web application."
    },
    {
       "key":266,
       "value":"Password Authentication Protocol (PAP)",
       "description":"A standardized authentication protocol for PPP. PAP transmits usernames and passwords in the clear. PAP offers no form of encryption; it simply provides a means to transport the logon credentials from the client to the authentication server."
    },
    {
       "key":267,
       "value":"Password Complexity",
       "description":"A security setting that enforces a specific requirement, such as requiring specific character types, not allowing dictionary words, or other attempts to ensure the password is not easily cracked."
    },
    {
       "key":268,
       "value":"Password Reuse",
       "description":"Repeating the use of a password, often on unrelated systems. In the event of a breach, password reuse means multiple systems or services could be breached using the same account and password."
    },
    {
       "key":269,
       "value":"Password Spraying Attack",
       "description":"An attack in which the attacker uses the same password against many different accounts, then uses another password against many accounts, continuing to attempt breaches until their goal is met or they are unable to log in."
    },
    {
       "key":270,
       "value":"Password Vaults",
       "description":"Software solutions that store, manage, and secure passwords and other information, allowing users to use strong passwords without memorizing dozens or hundreds of individual complex passwords."
    },
    {
       "key":271,
       "value":"Patch Management",
       "description":"Program that ensures that relevant patches are applied to systems. Ideally, patches are evaluated, tested, and deployed, and systems are audited to verify that the patches are applied and not removed."
    },
    {
       "key":272,
       "value":"Patching Procedures",
       "description":"Procedures that describe the frequency and process of applying patches to applications and systems under the organization\u0027s care."
    },
    {
       "key":273,
       "value":"Pattern Matching",
       "description":"A mechanism of action used by data loss prevention (DLP) systems that watches for the telltale signs of sensitive information."
    },
    {
       "key":274,
       "value":"Payment Card Industry Data Security Standard (PCI-DSS)",
       "description":"Standard that prescribes specific security controls for merchants who handle credit card transactions and service providers who assist merchants with these transactions."
    },
    {
       "key":275,
       "value":"Penetration Testing",
       "description":"An activity used to test the strength and effectiveness of deployed security measures with an authorized attempted intrusion attack. Penetration testing should be performed only with the consent and knowledge of management."
    },
    {
       "key":276,
       "value":"Persistence",
       "description":"The attempts of attackers to ensure they have ongoing access to a system. Personally Identifiable Information (PII) Any data item that is linked back to the human from whom it was gleaned."
    },
    {
       "key":277,
       "value":"Pharming",
       "description":"A phishing practice that uses malicious code on compromised systems to send unsuspecting users to malicious websites."
    },
    {
       "key":278,
       "value":"Phishing",
       "description":"A form of social engineering in which you ask someone for a piece of information that you are missing by making it look as if it is a legitimate request. Commonly sent via email."
    },
    {
       "key":279,
       "value":"Phishing Simulation",
       "description":"A training that sends users fake phishing messages to test their skills. Physical Controls The control access measures used to restrict physical access and prevent direct contact with systems or areas within a facility to protect assets and resources."
    },
    {
       "key":280,
       "value":"Pivoting",
       "description":"A phase of the penetration test that occurs as the attacker uses the initial system compromise to gain access to other systems on the target network."
    },
    {
       "key":281,
       "value":"Plain Text or Plaintext",
       "description":"Nonencrypted data."
    },
    {
       "key":282,
       "value":"Platform as a Service (PaaS)",
       "description":"A cloud service model in which the consumer can deploy tools using a platform but does not manage or control any of the underlying cloud infrastructure."
    },
    {
       "key":283,
       "value":"Policy",
       "description":"A document that defines the scope of security needs of an organization, prescribes solutions to manage security issues, and discusses the assets that need protection and the extent to which security solutions should go to provide the necessary protection. Strategic written governance."
    },
    {
       "key":284,
       "value":"Port Mirror",
       "description":"A tool that sends a copy of all the traffic sent from one switch port to another switch port for monitoring."
    },
    {
       "key":285,
       "value":"Port Security",
       "description":"A network device setting that attempts to prevent unauthorized devices from connecting to the network using MAC address filtering."
    },
    {
       "key":286,
       "value":"Potentially Unwanted Programs (PUPs)",
       "description":"Programs that may not be wanted by the user but that are not as dangerous as other types of malware."
    },
    {
       "key":287,
       "value":"Predictive Analysis",
       "description":"The use of data to attempt to predict events, used in a security context to identify potential compromises and attacks."
    },
    {
       "key":288,
       "value":"Pretexting",
       "description":"When someone claiming to be someone else convinces a third entity to give up sensitive or personal information."
    },
    {
       "key":289,
       "value":"Preventive Controls",
       "description":"A type of access control that is deployed to thwart or stop unwanted or unauthorized activity from occurring."
    },
    {
       "key":290,
       "value":"Privacy Notice",
       "description":"A document that outlines privacy commitments."
    },
    {
       "key":291,
       "value":"Private Cloud",
       "description":"A cloud delivery model owned and managed internally or for a single customer."
    },
    {
       "key":292,
       "value":"Privileged Access Management (PAM)",
       "description":"A tool that can be used to handle administrative and privileged accounts."
    },
    {
       "key":293,
       "value":"Privilege Escalation",
       "description":"The result of users obtaining access to a resource that they wouldn\u0027t normally be able to access. Common privilege escalation attack methods include running a program with Set User ID (SUID) or Set Group ID (SGID) permissions in Linux or Unix operating systems, or by temporarily becoming another user (via su or sudo in Unix/Linux or RunAs in Windows). It can also be done purposefully by an attacker seeking full access."
    },
    {
       "key":294,
       "value":"Privileges Required Metric",
       "description":"A metric that describes the type of account access that an attacker would need to exploit a vulnerability."
    },
    {
       "key":295,
       "value":"Procedure",
       "description":"In the context of security, a detailed step-by-step how-to document describing the actions necessary to implement a specific security mechanism, control, or solution."
    },
    {
       "key":296,
       "value":"Protected Cable Distribution",
       "description":"Physical security measures used to ensure that wiring and cables remain secure and that breaches of security are reported to responsible parties."
    },
    {
       "key":297,
       "value":"Protected Extensible Authentication Protocol (PEAP)",
       "description":"A protocol tool that encapsulates EAP methods within a TLS tunnel that provides authentication and potentially encryption."
    },
    {
       "key":298,
       "value":"Protected Health Information (PHI)",
       "description":"Data item that includes medical records maintained by health-care providers and other organizations that are subject to the Health Insurance Portability and Accountability Act (HIPAA)."
    },
    {
       "key":299,
       "value":"Provenance",
       "description":"A term describing the validity and history of data or a device, used to determine if it is trustworthy."
    },
    {
       "key":300,
       "value":"Proxy Server",
       "description":"A type of server that makes a single Internet connection and services requests on behalf of many users. Proxies may be forward or reverse proxies."
    },
    {
       "key":301,
       "value":"Public Cloud",
       "description":"A cloud delivery model available to others."
    },
    {
       "key":302,
       "value":"Purpose Limitation",
       "description":"The concept that information should only be used for the purpose that it was originally collected and consented to by the data subjects."
    },
    {
       "key":303,
       "value":"Push Notification",
       "description":"Messages sent to a user to inform them of an event, in this case an authentication attempt."
    },
    {
       "key":304,
       "value":"Quality Assurance (QA)",
       "description":"The process of ensuring that software or code meets quality standards through testing and other validation processes."
    },
    {
       "key":305,
       "value":"Qualitative Risk Assessment",
       "description":"A kind of risk assessment that substitutes subjective judgments and categories for strict numerical analysis, allowing the assessment of risks that are difficult to quantify."
    },
    {
       "key":306,
       "value":"Quality of Service (QoS)",
       "description":"A collection of technologies that provide the ability to balance network traffic and prioritize workloads."
    },
    {
       "key":307,
       "value":"Quantitative Risk Assessment",
       "description":"A kind of risk assessment that uses numeric data in the analysis, resulting in assessments that allow the straightforward prioritization of risks."
    },
    {
       "key":308,
       "value":"Race Condition",
       "description":"A situation that occurs when the security of a code segment depends on the sequence of events occurring within the system."
    },
    {
       "key":309,
       "value":"Radio Frequency Identification (RFID)",
       "description":"A technology that uses electromagnetic or electrostatic coupling in the radio frequency (RF) portion of the electromagnetic spectrum to identify a specific device. Each RFID tag includes a unique identifier so that when a nearby antenna/transceiver activates the tag, it transmits that identifier back to the antenna where that value is recorded or used to trigger some kind of action. For example, most modern toll-road systems use RFID devices that drivers attach to the windshield of their car, and each time a device is \u0022read\u0022 by an antenna, the vehicle owner\u0027s toll balance is incremented by the cost of that transit. RFID devices may also be used to track individuals (carrying tags), equipment (bearing tags), and so forth, within the premises of an enterprise for security monitoring."
    },
    {
       "key":310,
       "value":"Ransomware",
       "description":"Software that demands payment before restoring the data or system infected."
    },
    {
       "key":311,
       "value":"Real Evidence",
       "description":"Consists of things that may actually be brought into a court of law; also known as object evidence."
    },
    {
       "key":312,
       "value":"Recovery Point Objective (RPO)",
       "description":"A measure of how much data loss can be accepted by the organization when a disaster occurs. RPO is the maximum amount of time that can elapse between your backups, thus determining how much data could be lost in a disaster."
    },
    {
       "key":313,
       "value":"Recovery Time Objective (RTO)",
       "description":"The amount of time in which you think you can feasibly recover function in the event of a disruption."
    },
    {
       "key":314,
       "value":"Red Team",
       "description":"A term used to describe a penetration testing team that attempts to break into systems; the aggressor team. See also blue team and white team."
    },
    {
       "key":315,
       "value":"Redundancy",
       "description":"The implementation of secondary or alternate solutions or the means to perform work tasks or accomplish IT functions."
    },
    {
       "key":316,
       "value":"Refactoring",
       "description":"Restructuring an existing program or application."
    },
    {
       "key":317,
       "value":"Reflected Input",
       "description":"When a vulnerable website is fed script commands through form fields in such a manner as to trick the site, and the input is reflected back to a visitor as if it were original and legitimate content."
    },
    {
       "key":318,
       "value":"Regulatory Requirements",
       "description":"Requirements created by regulations and laws applicable to an organization."
    },
    {
       "key":319,
       "value":"Remote Authentication Dial-in User Service (RADIUS)",
       "description":"A centralized authentication, authorization, and accounting service, often used for VPN connections."
    },
    {
       "key":320,
       "value":"Remote File Inclusion",
       "description":"A kind of file inclusion attack that allows the attacker to go a step further and execute code that is stored on a remote server."
    },
    {
       "key":321,
       "value":"Reputational Risk",
       "description":"The risk that the negative publicity surrounding a security breach causes the loss of goodwill among customers, employees, suppliers, and other stakeholders."
    },
    {
       "key":322,
       "value":"Request Forgery",
       "description":"An attack that exploits trust relationships and attempts to have users unwittingly execute commands against a remote server."
    },
    {
       "key":323,
       "value":"Residual Risk",
       "description":"The risk that remains after an organization implements controls designed to mitigate, avoid, and/or transfer the inherent risk."
    },
    {
       "key":324,
       "value":"Resource Exhaustion",
       "description":"The situation in which systems consume all the memory, storage, processing time, or other resources available to them, rendering the system disabled or crippled for other uses."
    },
    {
       "key":325,
       "value":"Resource Policies",
       "description":"Policies offered by cloud providers that customers use to limit the actions that users of their accounts may take."
    },
    {
       "key":326,
       "value":"Restoration Order",
       "description":"The order in which systems and services should be restored in the event of a disaster to ensure proper restoration and to avoid service dependency issues."
    },
    {
       "key":327,
       "value":"Retina Scan",
       "description":"An example of a biometric factor, which is a behavioral or physiological characteristic that is unique to a subject. The blood vessel pattern at the back of the eyeball is used to establish identity or provide authentication."
    },
    {
       "key":328,
       "value":"Reverse Proxy",
       "description":"A type of proxy that is placed between servers and clients and that is used to help with load balancing and caching of content."
    },
    {
       "key":329,
       "value":"Right-to-Audit Clause",
       "description":"A part of the contract between a service provider and an organization, which provides either a direct ability to audit the provider or an agreement to use a third-party audit agency."
    },
    {
       "key":330,
       "value":"Risk",
       "description":"The seriousness of an event to an organization based on a combination of the likelihood of that event occurring and the negative impact of the event if it does occur."
    },
    {
       "key":331,
       "value":"Risk Acceptance",
       "description":"A risk management option that involves deliberately choosing to take no other risk management strategy and to continue operations as normal in the face of the risk."
    },
    {
       "key":332,
       "value":"Risk Appetite",
       "description":"An organization\u0027s willingness to tolerate risk within the environment."
    },
    {
       "key":333,
       "value":"Risk Assessment",
       "description":"An evaluation of how much risk you and your organization are willing to take. An assessment must be performed before any other actions, such as determining how much to spend for security in terms of dollars and labor."
    },
    {
       "key":334,
       "value":"Risk Avoidance",
       "description":"The process of selecting alternate options or activities that have less associated risk than the default, common, expedient, or cheap option."
    },
    {
       "key":335,
       "value":"Risk Calculation",
       "description":"The process of calculating the risks that exist in terms of costs, number, frequency, and so forth."
    },
    {
       "key":336,
       "value":"Risk Identification Process",
       "description":"The process of identifying the threats and vulnerabilities that exist in the operating environment."
    },
    {
       "key":337,
       "value":"Risk Management",
       "description":"A detailed process of identifying factors that could damage or disclose data, evaluating those factors in light of data value and countermeasure cost, and implementing cost-effective solutions for mitigating or reducing risk."
    },
    {
       "key":338,
       "value":"Risk Matrix",
       "description":"An approach that quickly summarizes risks and allows senior leaders to quickly focus on the most significant risks facing the organization."
    },
    {
       "key":339,
       "value":"Risk Mitigation",
       "description":"The implementation of safeguards and countermeasures to eliminate vulnerabilities or block threats."
    },
    {
       "key":340,
       "value":"Risk Transference",
       "description":"A strategy of dealing with risk by offloading some of the risk through insurance, third-party contracts, and/or shared responsibility."
    },
    {
       "key":341,
       "value":"Role-Based Training",
       "description":"A type of training that ensures that individuals receive the appropriate level of training based on their job responsibilities."
    },
    {
       "key":342,
       "value":"Rootkits",
       "description":"Software programs that have the ability to obtain root-level access and hide certain things from the operating system."
    },
    {
       "key":343,
       "value":"Rule-Based Access Control",
       "description":"A variation of mandatory access controls. A rule-based system uses a set of rules, restrictions, or filters to determine what can and cannot occur on the system, such as granting subject access, performing an action on an object, or accessing a resource. Firewalls, proxies, and routers are common examples of rule-based access control systems."
    },
    {
       "key":344,
       "value":"Rules of Engagement (RoE)",
       "description":"The rules that are agreed to for a penetration test. These rules are defined before the test starts to ensure that the test does not cause inadvertent harm or go beyond the accepted scope."
    },
    {
       "key":345,
       "value":"Sandboxing",
       "description":"A security technique that provides a security boundary for applications and prevents the application from interacting with other applications. Antimalware applications use sandboxing techniques to test unknown applications. If the application displays suspicious characteristics, the sandboxing technique prevents the application from infecting other applications or the operating system."
    },
    {
       "key":346,
       "value":"Sarbanes–Oxley (SOX) Act",
       "description":"A regulation that applies to the financial records of U.S. publicly traded companies and requires that those companies have a strong degree of assurance for the IT systems that store and process those records."
    },
    {
       "key":347,
       "value":"Scalability",
       "description":"A principle of application resilience that says that applications should be designed so that computing resources they require may be incrementally added to support increasing demand."
    },
    {
       "key":348,
       "value":"Scanless",
       "description":"A port scanner that uses third-party scanners and open source intelligence (OSINT) to gather information."
    },
    {
       "key":349,
       "value":"Scan Perspective",
       "description":"An aspect that conducts the scan from a different location on the network, providing a different view into vulnerabilities."
    },
    {
       "key":350,
       "value":"Scarcity",
       "description":"A key principle used for social engineering in scenarios that make something look more desirable because it may be the last one available."
    },
    {
       "key":351,
       "value":"Scope Metric",
       "description":"A measure that describes whether the vulnerability can affect system components other than those containing the vulnerability."
    },
    {
       "key":352,
       "value":"Script Kiddie",
       "description":"A derogatory term for people who use hacking techniques but have limited skills."
    },
    {
       "key":353,
       "value":"Secondary Evidence",
       "description":"Copies or descriptions of original evidence; not accepted as evidence unless certain exceptions to the rule apply."
    },
    {
       "key":354,
       "value":"Secure Web Gateways (SWGs)",
       "description":"Provide a layer of application security for clouddependent organizations."
    },
    {
       "key":355,
       "value":"Security Awareness",
       "description":"Less formal efforts that are designed to remind employees about the security lessons they\u0027ve already learned."
    },
    {
       "key":356,
       "value":"Security Controls",
       "description":"The safeguards or countermeasures used to address security vulnerabilities to reduce or manage risk."
    },
    {
       "key":357,
       "value":"Security Event",
       "description":"Any observable occurrence in a system or network that relates to a security function."
    },
    {
       "key":358,
       "value":"Security Incidents",
       "description":"A violation or imminent threat of a violation of a security policy or practice within the organization."
    },
    {
       "key":359,
       "value":"Security Information and Event Management (SIEM)",
       "description":"Systems that correlate log entries from multiple sources and provide actionable intelligence."
    },
    {
       "key":360,
       "value":"Security Requirements Definition",
       "description":"Ensures that the application is designed to be secure and that secure coding practices are used."
    },
    {
       "key":361,
       "value":"Security Training",
       "description":"A form of instruction that is intended to equip members of an organization with the information they need to protect themselves and their organization\u0027s assets from loss or harm."
    },
    {
       "key":362,
       "value":"Segmentation",
       "description":"The act of subdividing a network into numerous smaller units. These smaller units, groupings, segments, or subnetworks (subnets) can be used to improve various aspects of the network. Segmentation can boost performance, reduce congestion, compartmentalize communication problems (such as broadcast storms), and provide security improvements through traffic isolation. Segments can be created by using switch-based VLANs, routers, or firewalls (as well as combinations of all of these)."
    },
    {
       "key":363,
       "value":"Self-Signed Certificates",
       "description":"A security certification that is not signed by a recognized thirdparty certificate authority but is created within an organization."
    },
    {
       "key":364,
       "value":"Separation of Duties",
       "description":"A set of policies designed to reduce the risk of fraud and prevent other losses in an organization."
    },
    {
       "key":365,
       "value":"Server-Based Scanning",
       "description":"An approach to vulnerability scanning that relies on servers rather than local agents."
    },
    {
       "key":366,
       "value":"Serverless Computing",
       "description":"An approach that does not expose customers to the actual server instances executing their code."
    },
    {
       "key":367,
       "value":"Server-Side Request Forgery",
       "description":"An attack that exploits a vulnerability but rather than tricking a user\u0027s browser into visiting a URL, they trick a server into visiting a URL based on usersupplied input."
    },
    {
       "key":368,
       "value":"Service Level Agreements (SLAs)",
       "description":"Written contracts that specify the conditions of service that will be provided by the vendor and the remedies available to the customer if the vendor fails to meet the SLA."
    },
    {
       "key":369,
       "value":"Service Organization Control (SOC) Reports",
       "description":"Audit reporting formats created by the American Institute of Certified Public Accountants (AICPA), under the SSAE 18 standard. SOC reports define two SOC types and three kinds of SOC report (SOC 1, 2, and 3) that provide information about controls. SOC Type I reports describe controls as designed, whereas SOC Type II reports describe the effectiveness of the controls in addition to the design of the controls."
    },
    {
       "key":370,
       "value":"Session Hijacking",
       "description":"An attack that occurs when a malicious individual intercepts part of a communication between an authorized user and a resource and then uses a hijacking technique to take over the session and assume the identity of the authorized user."
    },
    {
       "key":371,
       "value":"Session Replay Attack",
       "description":"An attack that captures portions of a session to play back later to convince a host that it is still talking to the original connection."
    },
    {
       "key":372,
       "value":"Shared Responsibility Model",
       "description":"A cloud security framework that dictates the security obligations of a cloud computing provider and its users to ensure accountability."
    },
    {
       "key":373,
       "value":"Signature Detection",
       "description":"Uses databases of known malware patterns and scans the file and memory of a system for any data matching the pattern of known malicious software."
    },
    {
       "key":374,
       "value":"Simulation",
       "description":"Simulations are used to practice security processes and procedures, and attempt to emulate an actual event in a safe way to provide useful information and feedback."
    },
    {
       "key":375,
       "value":"Simultaneous Authentication of Equals (SAE)",
       "description":"An authentication method in WPA-3 that relies on a secure password-based authentication and password-authenticated key agreement to prevent brute-force attacks like those that would be used against preshared keys."
    },
    {
       "key":376,
       "value":"Single Loss Expectancy (SLE)",
       "description":"The cost associated with a single realized risk against a specific asset. The SLE indicates the exact amount of loss an organization would experience if an asset were harmed by a specific threat. SLE = asset value ($) * exposure factor (EF)."
    },
    {
       "key":377,
       "value":"Single Point of Failure",
       "description":"Any one item, element, or pathway that could cause significant downtime or system failure if broken, offline, or overloaded."
    },
    {
       "key":378,
       "value":"Site Survey",
       "description":"A formal assessment of wireless signal strength, quality, and interference using an RF signal detector."
    },
    {
       "key":379,
       "value":"Site-to-Site VPN",
       "description":"A VPN that connects to networks, rather than connecting a system to a remote network."
    },
    {
       "key":380,
       "value":"Smishing",
       "description":"A phishing technique that uses phishing via SMS (text) messages and vishing or phishing via telephone."
    },
    {
       "key":381,
       "value":"Software as a Service (SaaS)",
       "description":"A derivative of platform as a service that provides ondemand online access to specific software applications or suites without the need for local installation (or even local hardware and operating system requirements in many cases)."
    },
    {
       "key":382,
       "value":"Software Compliance/Licensing Risk",
       "description":"Risk that occurs when an organization licenses software from a vendor and intentionally or accidentally runs afoul of usage limitations that expose the customer to financial and legal risk."
    },
    {
       "key":383,
       "value":"Software-Defined Network (SDN)",
       "description":"A network that is controlled and configured using code and software."
    },
    {
       "key":384,
       "value":"Software-Defined Visibility (SDV)",
       "description":"A code-defined visibility infrastructure. Spam Unwanted, unsolicited email sent in bulk."
    },
    {
       "key":385,
       "value":"Spear Phishing",
       "description":"Phishing aimed at specific individuals or groups."
    },
    {
       "key":386,
       "value":"Spiral",
       "description":"A software development life cycle model that moves through four phases— identification, design, build, and evaluation—in a repeated cycle until completed."
    },
    {
       "key":387,
       "value":"Split-Tunnel VPN",
       "description":"A virtual private network (VPN) that only sends traffic intended for systems on the remote trusted network through the VPN tunnel."
    },
    {
       "key":388,
       "value":"Sprint",
       "description":"A short working session lasting from a few days to a few weeks in the Agile software development methodology."
    },
    {
       "key":389,
       "value":"Spyware",
       "description":"Software programs that work—often actively—on behalf of a third party. Staging Environment A transition environment for code that has successfully cleared testing and is waiting to be deployed into production."
    },
    {
       "key":390,
       "value":"Standards",
       "description":"Documents that define compulsory requirements for the homogenous use of hardware, software, technology, and security controls. They provide a course of action by which technology and procedures are uniformly implemented throughout an organization. Standards are tactical documents that define steps or methods to accomplish the goals and overall direction defined by security policies."
    },
    {
       "key":391,
       "value":"Strategic Risk",
       "description":"The risk that an organization will become less effective in meeting its major goals and objectives as a result of an impact."
    },
    {
       "key":392,
       "value":"Supply Chain Attack",
       "description":"A kind of attack that attempts to compromise devices, systems, or software before they even reach the organization."
    },
    {
       "key":393,
       "value":"SWOT Analysis",
       "description":"A technique commonly used by organizations to assess their current state and develop their forward-looking strategy based on identification and analysis of strengths, weaknesses, opportunities, and threats."
    },
    {
       "key":394,
       "value":"Symmetric Cipher",
       "description":"Any cryptographic algorithm that uses the same key to encrypt and decrypt. DES, AES, and Blowfish are examples."
    },
    {
       "key":395,
       "value":"Symmetric Cryptosystems",
       "description":"Uses a shared secret key available to all users of the cryptosystem."
    },
    {
       "key":396,
       "value":"System Resilience",
       "description":"The ability of a system to maintain an acceptable level of service during an adverse event."
    },
    {
       "key":397,
       "value":"Tabletop Exercise",
       "description":"An exercise that involves individuals sitting around a table with a facilitator discussing situations that could arise and how best to respond to them."
    },
    {
       "key":398,
       "value":"Tailgating",
       "description":"Following someone through an entry point."
    },
    {
       "key":399,
       "value":"Technical Controls",
       "description":"Enforce confidentiality, integrity, and availability in the digital space."
    },
    {
       "key":400,
       "value":"Threat Intelligence",
       "description":"The set of activities and resources available to cybersecurity professionals seeking to learn about changes in the threat environment."
    },
    {
       "key":401,
       "value":"Threat Landscape",
       "description":"As adversaries adapt their tactics and techniques, your cybersecurity strategy must evolve to combat those changes."
    },
    {
       "key":402,
       "value":"Threat Maps",
       "description":"Provide a geographic view of threat intelligence."
    },
    {
       "key":403,
       "value":"Threat Vectors",
       "description":"The path or means by which an attack can gain access to a target in order to cause harm. This is also known as the attack vector."
    },
    {
       "key":404,
       "value":"Threats",
       "description":"Any possible events that might have an adverse impact on the confidentiality, integrity, and/or availability of our information or information systems."
    },
    {
       "key":405,
       "value":"Tokenization",
       "description":"The process of replacing sensitive values with a unique identifier using a lookup table."
    },
    {
       "key":406,
       "value":"Tool-Assisted Code Review",
       "description":"A code review process that relies on software or other tools to manage and assist the code review process."
    },
    {
       "key":407,
       "value":"Transmission Control Protocol/Internet Protocol (TCP/IP)",
       "description":"Suite of network protocols used to transfer information between systems in a standardized format. TCP/IP is the primary mechanism used to transport data on modern networks."
    },
    {
       "key":408,
       "value":"Trojans",
       "description":"Any application that masquerades as one thing in order to get past scrutiny and then does something malicious. One of the major differences between Trojan horses and viruses is that Trojan horses tend not to replicate themselves."
    },
    {
       "key":409,
       "value":"Trust",
       "description":"A fundamental attack principle that, much like familiarity, relies on a connection with the individual they are targeting. Unlike familiarity, which relies on targets thinking that something is normal, and thus familiar, social engineers who use this technique work to build a connection with their targets so that they will take the actions that they want them to take."
    },
    {
       "key":410,
       "value":"Trusted Platform Module (TPM)",
       "description":"A specification for a cryptoprocessor as well as the chip in a mainboard supporting this function. A TPM chip is used to store and process cryptographic keys for a hardware-supported or hardware-implemented hard drive encryption system."
    },
    {
       "key":411,
       "value":"Two-Person Control",
       "description":"A concept that is similar to separation of duties but with an important difference: instead of preventing the same person from holding two different privileges that are sensitive when used together, two-person control requires the participation of two people to perform a single sensitive action."
    },
    {
       "key":412,
       "value":"Type I Hypervisor",
       "description":"A hypervisor that provides virtualization by running directly on baremetal hardware."
    },
    {
       "key":413,
       "value":"Type II Hypervisor",
       "description":"A hypervisor that provides virtualization by running as an application supported by a host operating system."
    },
    {
       "key":414,
       "value":"Typo Squatting",
       "description":"Creating domains that are based on the misspelling of another."
    },
    {
       "key":415,
       "value":"Unified Threat Management (UTM)",
       "description":"A security device that includes traditional functions of a firewall such as packet filtering and stateful inspection. It is able to perform packet inspection techniques, allowing it to identify and block malicious traffic. It can filter malware using definition files and/or whitelists and blacklists. It also includes intrusion detection and/ or intrusion prevention capabilities. Also known as a next-generation firewall."
    },
    {
       "key":416,
       "value":"Uninterruptible Power Supply (UPS)",
       "description":"A device that can provide short-term power, usually by using batteries."
    },
    {
       "key":417,
       "value":"Unit Testing",
       "description":"A method of testing software. Each unit of code is tested independently to discover any errors or omissions and to ensure that it functions properly. Unit testing should be performed by the development staff."
    },
    {
       "key":418,
       "value":"User Acceptance Testing (UAT)",
       "description":"A software development phase that ensures that the users of the software are satisfied with its functionality."
    },
    {
       "key":419,
       "value":"Version Control",
       "description":"A feature allowing the tracking of changes and the rollback of code to earlier versions when required."
    },
    {
       "key":420,
       "value":"Vertical Scaling",
       "description":"Increases the capacity of existing servers by using more powerful hardware or systems."
    },
    {
       "key":421,
       "value":"Virtual Desktop Infrastructure (VDI)",
       "description":"A VDI provides users with a desktop hosted on a server. Users can typically access the desktop from any device, including desktop computers and mobile devices. Virtual desktops can be persistent (meaning that they retain changes made by the user) or nonpersistent (meaning that the desktop reverts to its original state after the user logs off). It is sometimes called a virtual desktop environment (VDE)."
    },
    {
       "key":422,
       "value":"Virtual Machine (VM)",
       "description":"A software simulation of a computer within which a process executes. Each virtual machine has its own memory address space, and communication between virtual machines is securely controlled."
    },
    {
       "key":423,
       "value":"Virtual Machine Escape",
       "description":"The process of breaking out of the constraints of a virtual machine environment to attack or compromise the host system or software."
    },
    {
       "key":424,
       "value":"Virtual Machine Sprawl",
       "description":"An issue that occurs when virtual machine users create virtual machine instances and then forget about them or abandon them, leaving them to accrue costs and accumulate security issues over time."
    },
    {
       "key":425,
       "value":"Virtual Private Cloud (VPC)",
       "description":"A \u0022data center in the cloud,\u0022 a VPC is used in infrastructureas-a-service (IaaS) environments as the network that is defined for an organization as their cloud environment."
    },
    {
       "key":426,
       "value":"Virtualization",
       "description":"Emulating one or more physical computers on the same host. Virus A program intended to damage a computer system."
    },
    {
       "key":427,
       "value":"Vishing",
       "description":"Combining phishing with Voice over IP (VoIP)."
    },
    {
       "key":428,
       "value":"VLAN",
       "description":"A logical network segmentation implemented on switches and bridges to manage traffic. Multiple VLANs can be hosted on the same switch but are isolated as if they are separate physical networks. Cross-VLAN communications can occur only through a routing function, often provided by a multilayer switch. VLANs function like physical network segments."
    },
    {
       "key":429,
       "value":"Voice Recognition",
       "description":"A system that relies on patterns, rhythms, and the sounds of a user\u0027s voice itself to recognize the user."
    },
    {
       "key":430,
       "value":"Vulnerability",
       "description":"A weakness. It can be due to the existence of a flaw, loophole, oversight, error, limitation, frailty, or susceptibility in the IT infrastructure or any other aspect of an organization. It can also be the result of the absence of a safeguard or countermeasure or a weakness in a protection measure."
    },
    {
       "key":431,
       "value":"Vulnerability Databases",
       "description":"A database of vulnerabilities, including information like the severity, fixes, and other information useful for both attackers and defenders."
    },
    {
       "key":432,
       "value":"Vulnerability Feeds",
       "description":"A subscription to information about vulnerabilities used by vulnerability scanners and other devices and systems to ensure that vulnerability identification and validation are current and up-to-date."
    },
    {
       "key":433,
       "value":"Vulnerability Management",
       "description":"A program used to detect weaknesses within an organization. Vulnerability scans and vulnerability assessments are two common elements of a vulnerability management program. Vulnerability scans are technical scans performed regularly, and vulnerability assessments are normally combined with a risk assessment."
    },
    {
       "key":434,
       "value":"Vulnerability Scanning",
       "description":"Identifying specific vulnerabilities in your network."
    },
    {
       "key":435,
       "value":"Walk-through",
       "description":"A type of exercise that takes a team through an incident step by step."
    },
    {
       "key":436,
       "value":"War Driving",
       "description":"The act of using a radio wave signal detector or a wireless network detector to locate wireless networks."
    },
    {
       "key":437,
       "value":"War Flying",
       "description":"The expansion of war driving to the use of drones and unmanned aerial vehicles (UAVs)."
    },
    {
       "key":438,
       "value":"Warm Site",
       "description":"A middle ground between hot sites and cold sites for disaster recovery specialists. A warm site always contains the equipment and data circuits necessary to rapidly establish operations but does not typically contain copies of the client\u0027s data."
    },
    {
       "key":439,
       "value":"Waterfall",
       "description":"A software development method that uses well-defined, sequential phases."
    },
    {
       "key":440,
       "value":"Watermarking",
       "description":"Systems or administrators apply electronic tags to sensitive documents; then the data loss prevention (DLP) system can monitor systems and networks for unencrypted content containing those tags."
    },
    {
       "key":441,
       "value":"Web Application Firewall (WAF)",
       "description":"A firewall specifically designed to protect web applications."
    },
    {
       "key":442,
       "value":"Web Metadata",
       "description":"A type of metadata that is embedded into websites as part of the code of the website but that is often invisible to everyday users."
    },
    {
       "key":443,
       "value":"Web Shell",
       "description":"A malicious web-based shell-like interface that allows the attacker to execute commands on the server and view the results in the browser."
    },
    {
       "key":444,
       "value":"Whaling",
       "description":"Phishing aimed at senior staff and organizational leadership or other highprofile targets."
    },
    {
       "key":445,
       "value":"White-Box",
       "description":"Also referred to as known environment tests; tests performed with the full knowledge of the underlying technology, configuration, and settings that will make up the target."
    },
    {
       "key":446,
       "value":"White-Hat Hackers",
       "description":"Hackers who act with authorization and seek to discover security vulnerabilities with the intent of correcting them. Also known as authorized attackers."
    },
    {
       "key":447,
       "value":"White Team",
       "description":"Cybersecurity exercise team that serves as observers and judges. See also blue team and red team."
    },
    {
       "key":448,
       "value":"Wi-Fi",
       "description":"A wireless network operating in the 2.4 GHz or 5 GHz range."
    },
    {
       "key":449,
       "value":"Wi-Fi Protected Access 2 (WPA2)",
       "description":"A revision of WPA upgrading the encryption to an AES variant known as CCMP. WPA2 can be deployed in personal mode with a preshared key authentication or in enterprise mode using 802.1x to leverage existing network authentication. To date, no real-world attack has compromised the encryption of a properly configured WPA2 wireless network."
    },
    {
       "key":450,
       "value":"Wi-Fi Protected Access 3 (WPA3)",
       "description":"The replacement for WPA2, which has been required to be supported in all Wi-Fi devices since the middle of 2018."
    },
    {
       "key":451,
       "value":"Worms",
       "description":"A form of malicious code that is self-replicating but that is not designed to impose direct harm on host systems. The primary purpose of a worm is to replicate itself to other systems and gather information. Worms are usually very prolific and often cause a denial of service because of their consumption of system resources and network bandwidth in their attempt to self-replicate."
    },
    {
       "key":452,
       "value":"Zero-Based Budgeting",
       "description":"Approaches that create a new budget from scratch, assuming a baseline of zero and asking managers to justify their entire proposed budget, rather than starting with their assumption that they will have the same amount of funding as they did the previous year."
    },
    {
       "key":453,
       "value":"Zero-Day Attacks",
       "description":"An attack on a system that exploits vulnerabilities that are unknown to others, including the vendor."
    },
    {
       "key":454,
       "value":"Zero-Day Vulnerabilities",
       "description":"Vulnerabilities that are unknown to the security community and as a result are not included in security tests performed by vulnerability scanners and other tools and have no patches available to correct them."
    },
    {
       "key":455,
       "value":"Zero-Trust Network",
       "description":"Network where users and systems are not trusted regardless of whether they are an internal or an external person or system, and where each action must be authenticated, authorized, and observed."
    }
  ]